import React, { useEffect, useState } from "react";
import VisitsService from "../../../../services/VisitsService";
import Buttons from "../../../../components/UI/Buttons";

const EmrStatusBar = (props) => {
  const { visitDetails } = props;
  const { visit_id, overall_status } = visitDetails;
  const [timeLineData, setTimeLineData] = useState({});
    const defaultIcon="greycircle";
    const completedIcon="greensmall";
    const failedIcon="red";
    const pendingIcon="bluecircle";

  useEffect(() => {
    if (visit_id) {
      fetchTimeLine();
    }
  }, [visit_id, overall_status]);

  const fetchTimeLine = async () => {
    try {
      const response = await VisitsService.getVisitChartTimeLine(visit_id);
      setTimeLineData(response || {});
    } catch (error) {
      console.error("Failed to fetch timeline", error);
    }
  };

  // Helper to determine if a step is active/completed for styling
  const isComplete = (progress) => progress === 100;

  const statusData = [
    {
      title: "Arrived",
      date: timeLineData.arrival_date,
      time: timeLineData.arrival_time,
      progress: timeLineData.arrival_progress || 0,
      button: {
        title: "Arrived",
        iconType: isComplete(timeLineData.arrival_progress) ? completedIcon : defaultIcon,
      },
    },
    {
      title: "History",
      date: timeLineData.history_date,
      time: timeLineData.history_time,
      progress: timeLineData.history_progress || 0,
      button: {
        title: "History",
        iconType: isComplete(timeLineData.history_progress) ? completedIcon : defaultIcon,
      },
    },
    {
      title: "Exam",
      date: timeLineData.exam_date,
      time: timeLineData.exam_time,
      progress: timeLineData.exam_progress || 0,
      button: {
        title: "Exam",
        iconType: isComplete(timeLineData.exam_progress) ? completedIcon : defaultIcon,
      },
    },
    {
      title: "MDM",
      date: timeLineData.mdm_date,
      time: timeLineData.mdm_time,
      progress: timeLineData.mdm_progress || 0,
      button: {
        title: "MDM",
        iconType: isComplete(timeLineData.mdm_progress) ? completedIcon : defaultIcon,
      },
    },
    {
      title: "Discharge",
      date: timeLineData.discharge_date,
      time: timeLineData.discharge_time,
      progress: 0, 
      button: {
        title: "Discharge",
        iconType: isComplete(timeLineData.discharge_progress) ? completedIcon : defaultIcon,
      },
    },
  ];

  return (
    <div className="d-flex statusbar-timeline">
      {statusData.map((status, index) => (
       <div className="statuscard" key={index}>
           <div className="d-flex position-relative" style={{width:'100%',alignItems:'center'}}> 
                <div className="" >
                    <Buttons title={status.button.title} iconType={status.button.iconType} acl={"any"} />
                </div>
                <div className="progress status-timeline">
                <div className="progress-bar"
                  role="progressbar"
                  style={{ width: `${status.progress || 0}%` }}
                >

                </div>
                </div>
            </div>
            <div className="text-center statusbar-timeline-list ">
              <p className="mb-0 text-dark">{status.title}</p>
              <div className="statuscard-date">
                {status.date} {status.time}
              </div>
            </div>
        </div>
       
      ))}
    </div>
  );
};

export default EmrStatusBar;
